import { InjectionToken } from '@angular/core';

export const EnvironmentOptionsService = new InjectionToken<boolean>('false');
